<template>
    <v-footer height="auto" absolute>
        <v-card flat tile class="flex">
            <v-card-actions class="grey lighten-2 justify-center">
                &copy; 2019 — <strong> Campi Asesores </strong>
            </v-card-actions>
        </v-card>
    </v-footer>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Common/Footer.vue